import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { navigationService } from '../services/navigationService';

/**
 * Hook to integrate navigation service with React Router
 * This should be used in the main App component or a high-level component
 */
export const useNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Set the navigate function in the service
    navigationService.setNavigate(navigate);
  }, [navigate]);

  useEffect(() => {
    // Track page changes
    const currentPath = location.pathname;
    const searchParams = location.search;
    
    // Add to history (excluding login page to avoid circular navigation)
    if (currentPath !== '/login') {
      navigationService.addToHistory(currentPath, searchParams);
    }
  }, [location]);

  return {
    goBack: () => navigationService.goBack(),
    handleApiFailure: () => navigationService.handleApiFailure(),
    hasPreviousPage: () => navigationService.hasPreviousPage(),
    getHistory: () => navigationService.getHistory(),
    clearHistory: () => navigationService.clearHistory()
  };
};
